// extracted by mini-css-extract-plugin
module.exports = {"disabled":"styles_disabled__IgZZG","secondaryLabel":"styles_secondaryLabel__3a9f-","primaryLabel":"styles_primaryLabel__2Kpt5","placeholder":"styles_placeholder__2tYqF"};